export default __webpack_public_path__ + "static/media/AttendanceIcon.e89cf5be.svg";